import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const GetTeamSignupFormsInputSchema = z.object({
  teamId: zExt.objectId(),
});

export const GetTeamSignupFormsOutputSchema = z.object({
  forms: z.array(
    z.object({
      _id: zExt.objectId(),
      name: z.string(),
      publishedAt: z.date().nullable(),
      hasSpotlight: z.boolean(),
    }),
  ),
});

export type GetTeamSignupFormsInput = z.infer<
  typeof GetTeamSignupFormsInputSchema
>;
export type GetTeamSignupFormsOutput = z.infer<
  typeof GetTeamSignupFormsOutputSchema
>;

export const getTeamSignupForms = {
  name: "getTeamSignupForms" as const,
  input: GetTeamSignupFormsInputSchema,
  output: GetTeamSignupFormsOutputSchema,
};
